<template>
  <div class="d-flex in-component">
    <v-col
      cols="12"
      class="py-0">
      <v-row>
        <v-col>
          <ValidationProvider
            v-slot="{ errors }"
            :name="label"
            :rules="disableGroup ? rules : null">
            <v-select
              v-model="selectedItems"
              :items="items"
              :value="value"
              item-text="label"
              item-value="value"
              multiple
              class="dropdown-field"
              :error-messages="errors[0]"
              :disabled="!disableGroup"
              item-disabled="disabled"
              solo
              dense
              @input="input($event)"
              @change="(val) => $emit('input', val)">
            </v-select>
          </ValidationProvider>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>

<script>
import SchemaController from '@/utils/schemaController'

export default {
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    },
    rules: {
      type: String,
      default: ''
    },
    disableGroup: {
      type: Boolean,
      required: true
    },
    optionFunc: {
      type: String,
      default: 'none'
    }
  },
  data () {
    return {
      items: [],
      selectedItems: [],
      allValueInItems: []
    }
  },
  computed: {
    allSelected () {
      return this.selectedItems.length === this.items.length
    },
    icon () {
      let icon = 'mdi-checkbox-blank-outline'
      if (this.allSelected) {
        icon = 'mdi-close-box'
      } else if (this.selectedItems.length > 0 && !this.allSelected) {
        icon = 'mdi-minus-box'
      }
      return icon
    }
  },
  async mounted () {
    this.init()
  },
  methods: {
    toggle () {
      this.$nextTick(() => {
        this.selectedItems = this.allSelected ? [] : this.allValueInItems.slice()
        this.$emit('input', this.selectedItems)
      })
    },
    async init () {
      this.items = this.optionFunc === 'none' ? this.options : await SchemaController[this.optionFunc]()
      this.allValueInItems = this.items.map((item) => item.value)
    },
    input (input) {
      if (input.length > 0) {
        const temp = this.items.filter((item) => item.value === input[0])
        for (let i = 0; i < this.items.length; i++) {
          this.items[i].disabled = this.items[i].type !== temp[0].type
        }
      } else {
        for (let i = 0; i < this.items.length; i++) {
          this.items[i].disabled = false
        }
      }
    }
  }
}
</script>

<style scoped>
.dropdown-field {
  width: 362px;
  margin-top: -10px;
}

.dropdown-field .v-input__control {
  height: 50px;
}
</style>
